import React from 'react'
import { FormikErrors } from 'formik'

import { FieldError } from '../fieldError/FieldError'

import { Grid } from '@percent/lemonade'
import styles from './FieldMeta.module.scss'

type CharacterCountProps = {
  charCount: number
  countLimit: number
}

type FieldMetaProps = {
  characterCount?: CharacterCountProps
  error?: string | string[] | FormikErrors<any> | FormikErrors<any>[] | undefined
}

export function FieldMeta({ characterCount, error }: FieldMetaProps) {
  const justify = characterCount ? 'space-between' : 'flex-start'

  return (
    <Grid className={styles.textAreaDetail} justify={justify}>
      <Grid.Col className={styles.column}>
        <FieldError error={error} />
      </Grid.Col>
      {characterCount && (
        <Grid.Col className={`${styles.counter} ${styles.column}`}>
          <span>
            {characterCount.charCount}/{characterCount.countLimit}
          </span>
        </Grid.Col>
      )}
    </Grid>
  )
}
